// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"261":"e9c993cc","332":"e9c993cc","983":"e9c993cc"}[chunkId] + ".chunk.css";
};